import { t } from "@/lib/i18n";
import Reveal from "@/components/Reveal";
import { BirdMark } from "@/components/Logo";

export default function Intro() {
  return (
    <section className="safe-x max-w-7xl mx-auto py-20 sm:py-28 lg:py-36" data-testid="home-intro">
      <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20 items-start">
        <Reveal>
          <p className="eyebrow mb-5">{t("home.introEyebrow")}</p>
          <h2 className="text-4xl sm:text-5xl font-semibold leading-[1.08] text-forest">{t("home.introTitle")}</h2>
        </Reveal>
        <Reveal delay={120}>
          <p className="text-lg sm:text-xl leading-relaxed text-ink-muted">{t("home.introText")}</p>
          <BirdMark className="mt-10" />
        </Reveal>
      </div>
    </section>
  );
}
